export const lightenColor = (hex) => {
	// Remove the # if present
	hex = hex.replace('#', '');

	// Convert to RGB
	let r = parseInt(hex.substring(0, 2), 16);
	let g = parseInt(hex.substring(2, 4), 16);
	let b = parseInt(hex.substring(4, 6), 16);

	// Lighten by 20%
	r = Math.min(255, Math.floor(r * 1.2));
	g = Math.min(255, Math.floor(g * 1.2));
	b = Math.min(255, Math.floor(b * 1.2));

	// Convert back to hex
	const newHex =
		'#' +
		r.toString(16).padStart(2, '0') +
		g.toString(16).padStart(2, '0') +
		b.toString(16).padStart(2, '0');

	return newHex;
};
